import { initialState } from "../duck/initialState";
import { coRenterState } from "./coRenterState";

const getRenterReferences = (arr) => arr.filter((a) => a.renter_id);
const getCoRenterReferences = (arr) => arr.filter((a) => a.corenter_id);

export default function populateContract(data, activeStep) {
  let renter = { ...initialState.renter };
  let coRenter = null;

  if (data.renter) {
    const dataRenter = data.renter;

    Object.keys(renter).forEach((k) => {
      if (k == "references") {
        return;
      }
      if (k == "birthdate") {
        renter.birthdate = dataRenter.birthdate
          ? new Date(dataRenter.birthdate)
          : null;
      } else {
        dataRenter[k] ? (renter[k] = dataRenter[k]) : null;
      }
    });

    renter.references.forEach((ref, i) => {
      // not sure why we have to do this, but seems to work
      Object.keys(ref).forEach((k) => {
        if (ref[k] === "id") {
          ref[k] = null;
        } else {
          ref[k] = "";
        }
      });

      const refs = getRenterReferences(data.references);
      if (refs[i]) {
        Object.keys(ref).forEach((k) => {
          refs[i][k] ? (renter.references[i][k] = refs[i][k]) : null;
        });
      }
    });
  }

  if (data.corenter) {
    const dataCoRenter = data.corenter;

    coRenter = { ...coRenterState };

    Object.keys(coRenterState).forEach((k) => {
      if (k == "references") {
        return;
      }
      if (k == "birthdate") {
        coRenter.birthdate = dataCoRenter.birthdate
          ? new Date(dataCoRenter.birthdate)
          : null;
      } else if (
        k == "drivers_license_image" ||
        k == "proof_of_income_image" ||
        k == "proof_of_residence_image"
      ) {
        dataCoRenter[k]
          ? (coRenter[k] = dataCoRenter[k])
          : (coRenter[k] = null);
      } else {
        dataCoRenter[k] ? (coRenter[k] = dataCoRenter[k]) : null;
      }
    });

    coRenter.references.forEach((ref, i) => {
      Object.keys(ref).forEach((k) => {
        if (ref[k] === "id") {
          ref[k] = null;
        } else {
          ref[k] = "";
        }
      });

      const refs = getCoRenterReferences(data.references);
      if (refs[i]) {
        Object.keys(ref).forEach((k) => {
          refs[i][k] ? (coRenter.references[i][k] = refs[i][k]) : null;
        });
      }
    });
  }

  let systems = [];

  const termRelatedKeys = [
    "additional_purchase_reserve",
    "cash_total",
    "cost_reduction_after_tax",
    "final_cost_of_unit",
    "minimum_purchase_reserve",
    "monthly_pretax",
    "monthly_tax",
    "tax_on_deposit",
    "total_monthly_payment",
    "total_purchase_reserve",
    "term",
    "tax_rate",
    "early_po_payoff",
    "full_term_payoff",
    "total_hvac_system_cost",
    "reduction_factor",
    "duration_divisor",
  ];

  let term = null;

  termRelatedKeys.forEach((t) => {
    if (data[t]) {
      term ? (term[t] = data[t]) : (term = { [t]: data[t] });
    }
  });

  if (term && !term.term) {
    term = null;
  }

  if (data.status !== "0" && data.status !== "9") {
    data.hvac_systems.forEach((sys) => systems.push(sys));
  } else {
    // check for old data, contracts that have been
    // made without contract_builder systems
    if (data.contract_builder_systems.length) {
      data.contract_builder_systems.forEach((sys) => systems.push(sys));
    } else {
      data.hvac_systems.forEach((sys) => systems.push(sys));
    }
  }

  return {
    activeStep,
    address: {
      address_1: data.address_1 ? data.address_1 : "",
      address_2: data.address_2 ? data.address_2 : "",
      city: data.city ? data.city : "",
      state: data.state ? data.state : "",
      zip: data.zip ? data.zip : "",
      county: data.county ? data.county : "",
    },
    coisGood: data.cois_good,
    coRenter,
    dealer: data.dealer ? data.dealer : null,
    defaultPricebook: data.use_default_pricebook,
    downPaymentOverrideAmount: data.override_dp_increase_in_pennies || 0,
    driversLicense: data.drivers_license_image
      ? data.drivers_license_image
      : null,
    error: null,
    id: data.id,
    initLoading: false,
    loading: false,
    payment: data.down_payment ? true : false,
    paymentSkipped: false,
    paymentTransactions: data.approved_payment_transactions
      ? data.approved_payment_transactions
      : [],
    pdfFilename: data.contract_pdf_filename ? data.contract_pdf_filename : "",
    proofOfIncome: data.proof_of_income_image
      ? data.proof_of_income_image
      : null,
    proofOfResidence: data.proof_of_residence_image
      ? data.proof_of_residence_image
      : null,
    remoteCode: data.remote_code ? true : false,
    remoteEmail: "",
    renter,
    salesperson: data.salesperson ? data.salesperson : null,
    showPricebookSelect: data.use_default_pricebook,
    showRemoteSuccess: false,
    showSuccess: false,
    statedIncome: data.stated_monthly_income_formatted || "",
    status: data.status ? data.status : 0,
    systems,
    term: {
      additionalCost:
        (data.additional_cost !== null) & (data.additional_cost !== undefined)
          ? data.additional_cost
          : "",
      additionalCostNote:
        (data.additional_cost_note !== null) &
        (data.additional_cost_note !== undefined)
          ? data.additional_cost_note
          : "",
      downPayment: data.additional_purchase_reserve
        ? data.additional_purchase_reserve
        : "",
      purchaseReserveReduction: data.purchase_reserve_reduction
        ? data.purchase_reserve_reduction
        : "",
      taxCounty: data.county ? data.county : "",
      taxState: data.tax_state ? data.tax_state : "",
      taxZip: data.tax_zip ? data.tax_zip : "",
      selected: term,
    },
    // voidedCheck: data.voided_check_image ? data.voided_check_image : null,
  };
}
